import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, UserLabelsService, Alert) {
        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
		this.labelName="";
    }
	create() {
	const companyId=this.companyId;
        this.isSaving = true;
        this.UserLabelsService
            .createLabel({companyId}, this.labelName).$promise
            .then((data) => {
						var transformedData=data.toJSON();
						this.labels.push(transformedData);
						this.$state.go('company.user-directories.saaspass-users.user-labels.import-users-to-label', {userLabelId: data.id})})
            .then(() => {
               // const key = 'company.user-directories.manage-group.accounts.move.moved';
               // const variables = {labelName: this.st.selectedItems[0].labelName};
               // this.Alert('success', key, variables);
            })
            .finally(() => this.isSaving = false)
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/create-label/create-label.controller.js